var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-checkInput" },
    [
      _c("Input", {
        attrs: {
          className: _vm.className,
          size: _vm.size,
          label: _vm.label,
          placeholder: _vm.placeholder,
          msg: _vm.isCheck ? _vm.errmsg : _vm.msg,
          showMsg: _vm.showMsg,
          error: _vm.isCheck ? _vm.inputError : _vm.error,
          disabled: _vm.disabled,
          type: _vm.type,
          isFocus: _vm.focused,
          isHover: _vm.hover,
          value: _vm.value,
          maxlength: _vm.maxlength
        },
        on: {
          keyup: _vm.handleKeyup,
          blur: _vm.handleBlur,
          input: _vm.handleInputChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }